import * as React from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { formatCityState } from '@purposity/utils'
import { FixedText } from '@components/FixedText'
import { withSkeleton } from '@components/Skeleton'
import { Spacer } from '@components/Spacer'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

function LocationTagBase({ city, state }: { city?: string; state?: string }) {
  const cityState = formatCityState(city, state)
  return cityState ? (
    <View style={styles.locationTagContainer}>
      <FontAwesomeIcon
        icon={findIconDefinition({
          prefix: 'fas',
          iconName: 'map-marker-alt',
        })}
        color={Colors.dotGray}
      />
      <Spacer width={4} />

      <FixedText lineHeight={1.2}>
        <Text style={styles.locationTagText}>{cityState}</Text>
      </FixedText>
    </View>
  ) : null
}

const styles = StyleSheet.create({
  locationTagContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  locationTagText: {
    fontFamily: Fonts.type.alternateBold,
    fontWeight: 'bold',
    fontSize: 13,
    color: Colors.textGray,
    textTransform: 'uppercase',
  },
  cardFooterWrapper: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
})

export const LocationTag = withSkeleton(LocationTagBase, {
  width: 95,
  height: 12,
})
